import React, { useState } from "react";
import useSaveSearch from "hooks/useSaveSearch";
import useProperties from "hooks/useProperties";
import { useLocation } from "react-router";
import { findLocationFromUrl } from "utils/searchFilter";
import { useSearchParams } from "react-router-dom";
import InputDialog from "./InputDialog";

const SearchSaveDialog = ({ isOpen, onClose }) => {
  const [validateName, setValidateName] = useState(null);
  const [searchName, setSearchName] = useState("");
  const { saveSearch, loading, error } = useSaveSearch();
  const { properties } = useProperties();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const locationIds = searchParams.getAll("locationId") || [];
  const searchedLocation = findLocationFromUrl(locationIds);

  // Add save search
  const handleSaveSearch = async () => {
    if (!searchName.trim()) {
      setValidateName("Inserisci un nome");
      setTimeout(() => {
        setValidateName(null);
      }, 5000);
      return;
    }

    const searchData = {
      url: location.pathname + location.search,
      location: searchedLocation?.name,
      propertiesCount: properties?.count || 0,
      searchName: searchName,
    };
    await saveSearch(searchData);
    onClose();
    setSearchName("");
  };

  return (
    <InputDialog
      isOpen={isOpen}
      isClose={onClose}
      buttonText="Salva"
      placeholder="nome della ricerca"
      label="Salva la Ricerca"
      onChange={(e) => setSearchName(e.target.value)}
      value={searchName}
      onClick={handleSaveSearch}
      loading={loading}
      validationError={validateName}
    />
  );
};

export default SearchSaveDialog;
